import format, { toCleanString } from "./format";

const applyMask = (value, mask) => {
    const tokens = {
        '#': { pattern: /\d/},
        'X': { pattern: /[0-9a-zA-Z]/},
        'S': { pattern: /[a-zA-Z]/},
        'A': { pattern: /[a-zA-Z]/, transform: (text) => text.toLocaleUpperCase() },
        'a': { pattern: /[a-zA-Z]/, transform: (text) => text.toLocaleLowerCase()},
        '!': { escape: true},
    };

    value = toCleanString(value);
    let output = '';
    let valueIndex = 0;
    let escaping = false;

    for(let maskIndex = 0; maskIndex < mask.length && valueIndex <value.length; maskIndex++){
        const maskChar = mask[maskIndex];

        if(escaping){
            output += maskChar;
            escaping = false;
            continue;
        }

        if(maskChar === '!'){
            escaping = true;
            continue;
        }

        const token = tokens[maskChar];

        if(token) {
            const char = value[valueIndex];

            if(token.pattern.test(char)){
                output += token.transform ? token.transform(char) : char;
            } else {
                maskIndex--;
            }
            valueIndex++;
            continue;
        }

        if(value[valueIndex] === maskChar) {
            valueIndex++;
        }
        output+=maskChar;
    }

    return output;
}

export const cpfMask = (value) => applyMask(value, "###.###.###-##");

export const cnpjMask = (value) => applyMask(value, "##.###.###/####-##");

export const documentMask = (value) => {

    const alphaNum = format.extractAlphanumerics(value);
    const digits = format.extractDigits(value);

    if(digits.length > 0 && digits === alphaNum){
        if (digits.length <= 11) {
            return cpfMask(digits);
        }
    
        if (digits.length <= 14) {
            return cnpjMask(digits);
        }
    }

    return alphaNum;
}

export const phoneMask = (value) => applyMask(value, "(##) # ####-####");

export const cepMask = (value) => applyMask(value, "#####-###");

export const creditCardMask = (value) => applyMask(value, "#### #### #### ####");

export const creditCardExpirationDateMask = (value) => applyMask(value, "##/##");

const masks = {
    cpf: cpfMask,
    cnpj: cnpjMask,
    document: documentMask,
    phone: phoneMask,
    cep: cepMask,
    creditCard: creditCardMask,
    creditCardExpirationDate: creditCardExpirationDateMask,
};

export default masks;